import React from 'react';
import { EmptyProjectIcon } from '../../Icons';
import * as Styled from './styles';
import { LinkComponent } from '../../Link';

type EmptyProjectStatePropTypes = {
  message: {
    title: string,
    description: string
    path?: string
    url?: string
    list?: string[]
  }
}
export const EmptyProjectState = ({ message }: EmptyProjectStatePropTypes) => (
  <Styled.EmptyStateWrapper>
    <EmptyProjectIcon />

    <Styled.ContainWrapperStyled>
      <Styled.TitleStyled>
        {message.title}
      </Styled.TitleStyled>
      <Styled.DescriptionStyled>{message.description}</Styled.DescriptionStyled>
      {message.url && (
        <Styled.LinkWrapper>
          <LinkComponent url={message.url} theme="buttonFourth">
            <div>
              {message.path}
            </div>
          </LinkComponent>
        </Styled.LinkWrapper>
      )}
    </Styled.ContainWrapperStyled>

    {message.list && (
      <Styled.ContainWrapperStyled theme="secondary">
        <Styled.ListStyled>
          {message.list.map((item) => (
            <Styled.ListItemStyled key={item.slice(0, 6)}>
              {item}
            </Styled.ListItemStyled>
          ))}
        </Styled.ListStyled>
      </Styled.ContainWrapperStyled>
    )}
  </Styled.EmptyStateWrapper>
);
